import { Table, TableReservation, Order, TableStats } from '../types';

export const mockTables: Table[] = [
  {
    id: '1',
    number: 1,
    capacity: 4,
    status: 'libre',
    position: { x: 100, y: 100 },
    shape: 'square',
    lastCleaned: '2024-08-01T08:00:00Z'
  },
  {
    id: '2',
    number: 2,
    capacity: 2,
    status: 'ocupada',
    position: { x: 200, y: 100 },
    shape: 'round',
    orderId: 'order-1',
    customerId: 'customer-1',
    occupiedSince: '2024-08-01T12:30:00Z'
  },
  {
    id: '3',
    number: 3,
    capacity: 6,
    status: 'reservada',
    position: { x: 300, y: 100 },
    shape: 'rectangle',
    reservationId: 'reservation-1'
  },
  {
    id: '4',
    number: 4,
    capacity: 4,
    status: 'limpieza',
    position: { x: 100, y: 200 },
    shape: 'square'
  }
];

export const mockReservations: TableReservation[] = [
  {
    id: 'reservation-1',
    tableId: '3',
    customerId: 'customer-2',
    customerName: 'Juan Pérez',
    date: '2024-08-01',
    time: '19:00',
    duration: 120,
    partySize: 6,
    status: 'confirmed',
    phoneNumber: '+51987654321',
    createdAt: '2024-08-01T10:00:00Z',
    notes: 'Cumpleaños'
  }
];

export const mockOrders: Order[] = [
  {
    id: 'order-1',
    tableId: '2',
    customerId: 'customer-1',
    items: [
      {
        id: 'item-1',
        productId: 'product-1',
        name: 'Sanguche Clásico',
        quantity: 2,
        unitPrice: 15.00,
        total: 30.00,
        status: 'served'
      },
      {
        id: 'item-2',
        productId: 'product-2',
        name: 'Gaseosa',
        quantity: 2,
        unitPrice: 5.00,
        total: 10.00,
        status: 'served'
      }
    ],
    subtotal: 40.00,
    tax: 7.20,
    total: 47.20,
    status: 'served',
    createdAt: '2024-08-01T12:30:00Z',
    updatedAt: '2024-08-01T13:00:00Z',
    waiterId: 'waiter-1'
  }
];

export const mockTableStats: TableStats = {
  totalTables: 4,
  occupiedTables: 1,
  reservedTables: 1,
  availableTables: 2,
  averageOccupancyTime: 45,
  totalRevenue: 250.50
};